var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Edit"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.78213 27.6392C7.86249 27.6392 7.94285 27.6312 8.0232 27.6191L14.7812 26.4339C14.8616 26.4178 14.9379 26.3816 14.9942 26.3214L32.0259 9.28966C32.0631 9.25249 32.0927 9.20834 32.1128 9.15973C32.133 9.11113 32.1434 9.05902 32.1434 9.0064C32.1434 8.95378 32.133 8.90167 32.1128 8.85307C32.0927 8.80446 32.0631 8.76031 32.0259 8.72314L25.3482 2.04144C25.2719 1.96511 25.1714 1.92493 25.0629 1.92493C24.9545 1.92493 24.854 1.96511 24.7777 2.04144L7.74597 19.0731C7.6857 19.1334 7.64954 19.2057 7.63347 19.2861L6.4482 26.0441C6.40912 26.2594 6.42308 26.4809 6.48889 26.6895C6.5547 26.8981 6.67037 27.0876 6.82588 27.2414C7.09106 27.4986 7.42454 27.6392 7.78213 27.6392V27.6392ZM10.4902 20.6321L25.0629 6.06332L28.008 9.00841L13.4353 23.5772L9.86338 24.208L10.4902 20.6321V20.6321ZM32.7853 31.0142H3.21383C2.50267 31.0142 1.92811 31.5888 1.92811 32.2999V33.7464C1.92811 33.9231 2.07275 34.0678 2.24954 34.0678H33.7495C33.9263 34.0678 34.071 33.9231 34.071 33.7464V32.2999C34.071 31.5888 33.4964 31.0142 32.7853 31.0142Z",
    fill: "black",
    fillOpacity: 0.85
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.55056e221db53f634e93ffc38c9db16a.svg";
export { ForwardRef as ReactComponent };